import { render } from "./OurProduct.vue?vue&type=template&id=903cb4bc"
import script from "./OurProduct.vue?vue&type=script&lang=js"
export * from "./OurProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__